import React from "react";

const lhNormal = { lineHeight: "normal" };
const fs12TNR = { fontSize: "12.0pt", fontFamily: "Times new Roman" };
const fs10TNR = {
  fontSize: "10.0pt",
  fontFamily: "Times new Roman",
  fontWeight: "bold"
}; //, fontFamily: '"Times new Roman",serif' }

export const content = (
  <div>
    <p style={lhNormal}>
      <span style={fs12TNR}>Effective Date: 6-1-19</span>
    </p>

    <p style={lhNormal}>
      <b>
        <span style={fs10TNR}>Welcome</span>
      </b>
    </p>

    <p style={lhNormal}>
      <span style={fs12TNR}>
        Welcome to Xooker Deal Marketplace™, a shopping and advertising
        information service brought to you by Xooker. These Terms of Service
        constitute a binding legal agreement between you (“you,” your” and/or
        “yourself”) and Xooker and its (“Xooker Deal Marketplace™”, “we”, “us”
        and/or “our”). Please read them carefully as they contain important
        information regarding your use of the Xooker Deal Marketplace™ sites and
        services, the terms of any purchase you may make through those sites and
        services, and may affect your legal rights.
      </span>
    </p>

    <p style={lhNormal}>
      <span style={fs12TNR}>
        THESE TERMS OF SERVICE CONTAIN A DISPUTE RESOLUTION AND ARBITRATION
        PROVISION (SECTION 11.3.), INCLUDING CLASS ACTION WAIVER THAT AFFECTS
        YOUR RIGHTS UNDER THESE TERMS OF SERVICE AND WITH RESPECT TO DISPUTES
        YOU MAY HAVE WITH XOOKER DEAL MARKETPLACE™. YOU MAY OPT OUT OF THE
        BINDING INDIVIDUAL ARBITRATION AND CLASS ACTION WAIVER AS PROVIDED IN
        SECTION 11.3. BELOW.
      </span>
    </p>

    <p style={lhNormal}>
      <b>
        <span style={fs10TNR}>
          1. Your Agreement with Xooker Deal Marketplace™
        </span>
      </b>
    </p>

    <p style={lhNormal}>
      <span style={fs12TNR}>
        You understand and agree that, by visiting or making any purchase on
        Xooker Deal Marketplace™, and any of its affiliated sites (each a
        “Site”), regardless of the medium or device by which you access or use
        the Site or services, you are accepting, without modification, these
        Terms of Service. IF YOU DO NOT AGREE WITH ANY PORTION OF THESE TERMS OF
        SERVICE, IMMEDIATELY STOP ACCESSING OR USING ANY OF THE XOOKER DEAL
        MARKETPLACE SITES OR SERVICES.
      </span>
    </p>

    <p style={lhNormal}>
      <span style={fs12TNR}>
        These Terms of Service include Xooker Deal Marketplace's Privacy Policy,
        located here:{" "}
      </span>
      <a href="https://xooker.com/privacy-policy/">
        https://xooker.com/privacy-policy/
      </a>
      <span style={fs12TNR}>
        which is incorporated into these Terms of Service by reference and
        together with the Terms of Service governs your visit to Xooker Deal
        Marketplace. The Privacy Policy explains Xooker Deal Marketplace's
        position on information gathering and how it intends to use and share
        any information it collects. Read the Privacy Policy carefully as you
        are agreeing to it when you agree to these Terms of Service.
      </span>
    </p>

    <p style={lhNormal}>
      <span style={fs12TNR}>
        By using any of the Sites, you are representing that
      </span>
    </p>

    <ol>
      <li style={lhNormal}>
        <span style={fs12TNR}>
          You are at least 18 years old, and you are capable of entering into
          and performing legal agreements;
        </span>
      </li>
      <li style={lhNormal}>
        <span style={fs12TNR}>
          You are making legitimate purchases for your personal use and
          enjoyment only, or when offered, as a gift for another; and
        </span>
      </li>
      <li style={lhNormal}>
        <span style={fs12TNR}>
          You have provided and will provide complete, accurate, truthful and
          up-to-date information to Xooker Deal Marketplace™ in connection with
          the creation of any account, purchases or other use of the Site.
        </span>
      </li>
    </ol>

    <p style={lhNormal}>
      <span style={fs12TNR}>
        These Terms of Service include Xooker Deal Marketplace's Privacy Policy,
        located here:{" "}
      </span>
      <a href="https://xooker.com/privacy-policy/">
        https://xooker.com/privacy-policy/
      </a>
      <span style={fs12TNR}>
        which is incorporated into these Terms of Service by reference and
        together with the Terms of Service governs your visit to any of the
        Xooker Deal Marketplace™ Sites. The Privacy Policy explains Xooker Deal
        Marketplace's position on information gathering and how it intends to
        use and share any information it collects. Read the Privacy Policy
        carefully as you are agreeing to it when you agree to these Terms of
        Service or use any of the Sites. In addition to these Terms of Service,
        the products and services offered through Xooker Deal Marketplace™ Sites
        may contain certain additional terms and restrictions that are meant to
        be in addition to the terms contained herein. Those additional terms and
        restrictions will govern your agreement with the Merchant from which you
        have purchased certificates for products and services on the Xooker Deal
        Marketplace Sites.
      </span>
    </p>

    <p style={lhNormal}>
      <b>
        <span style={fs10TNR}>2. Revisions to Terms of Service</span>
      </b>
    </p>

    <p style={lhNormal}>
      <span style={fs12TNR}>
        These Terms of Service are subject to revision from time to time by
        Xooker Deal Marketplace™ and your continued use of any Xooker Deal
        Marketplace Sites means you agree to, without modification, the revised
        Terms of Service. If you are a registered member of Xooker Deal
        Marketplace, you will be notified of material revisions to these Terms
        of Service via an e-mail message to the e-mail address that you provided
        at registration or that you have since updated. If you are not a
        registered member of Xooker Deal Marketplace™, then you can review
        revisions to these Terms of Service by regularly checking this page.
        Material revisions to these Terms of Service will be indicated by an
        updated effective date at the top left corner of this page. Whether or
        not you are a registered member of Xooker Deal Marketplace™, it is your
        responsibility to remain apprised of any revisions to these Terms of
        Service and to remain in compliance therewith. Should you object to any
        such revisions to these Terms of Service or become dissatisfied with
        Xooker Deal Marketplace™ in any way, your only recourse is to discontinue
        use of Xooker Deal Marketplace™ and immediately terminate your membership
        by sending your request via Xooker Deal Marketplace’s Contact Us page at{" "}
      </span>
      <a href="https://www.xookerdealmarketplace.com/contact-us">
        https://www.xookerdealmarketplace.com/contact-us
      </a>
      <span style={fs12TNR}>
        If you have registered for Xooker Deal Marketplace™ in more than one
        city, please list any or all cities to which your termination of
        membership is to apply in your request. Otherwise, continuing to use the
        membership service and continuing to visit Xooker Deal Marketplace™ after
        the effective date means that you agree to be bound by any and all
        revisions.
      </span>
    </p>

    <p style={lhNormal}>
      <b>
        <span style={fs10TNR}>3. Communication</span>
      </b>
    </p>

    <p style={lhNormal}>
      <span style={fs12TNR}>
        When you visit Xooker Deal Marketplace™ or send e-mails to us or text us,
        you are communicating with us electronically and thereby consent to
        receive communications from us electronically. We will communicate with
        you by e-mail, texting or by posting notices on the Site. You agree that
        all agreements, notices, disclosures and other communications that we
        provide to you electronically satisfy any legal requirement that such
        communications be in writing. Please note that because we do not control
        the Internet or any other network or device you may use to access the
        Site, we are not responsible or liable for the security of any
        information you may transmit or communicate to us and are not
        responsible for any loss of data during any such communication or
        transmission.
      </span>
    </p>

    <p style={lhNormal}>
      <b>
        <span style={fs10TNR}>4. Registration</span>
      </b>
    </p>

    <p style={lhNormal}>
      <span style={fs12TNR}>
        You will be required to register and become a member (“Members”) of
        Xooker Deal Marketplace™ to purchase deals and access and use certain
        other content, services and features on the Sites. You agree to register
        and hold only one account in your own name that you are solely
        responsible for managing. You will be issued a unique log-in
        identification (“User Id”) and password to access and use your account.
        As a Member of Xooker Deal Marketplace™, you accept responsibility for
        all activities that occur under your account whether or not you
        expressly authorize such activities. You are responsible for maintaining
        the confidentiality of your User Id and password and for restricting
        access to your computer or other devices (including mobile devices) so
        others may not access Xooker Deal Marketplace™ using your User Id or
        account in whole or in part. Xooker Deal Marketplace™ may terminate
        membership and deny access to Xooker Deal Marketplace™ to any person for
        any reason in its sole discretion. You will not compromise, or attempt
        to compromise, the security of your account and you will immediately
        notify us if you become aware of any loss, misuse, unauthorized use or
        theft of your User Id, password or account. Additionally and without
        limiting the generality of the preceding sentence, Xooker Deal
        Marketplace may terminate membership and deny access to Xooker Deal
        Marketplace to any person who, in Xooker Deal Marketplace's sole
        discretion, violates these Terms of Service. Such termination or denial
        of access shall be in addition to any remedies available to Xooker Deal
        Marketplace in law and equity.
      </span>
    </p>

    <p style={lhNormal}>
      <b>
        <span style={fs10TNR}>5. How Xooker Deal Marketplace™ Works</span>
      </b>
    </p>

    <p style={lhNormal}>
      <b>
        <span style={fs12TNR}>5.1. Role of Xooker Deal Marketplace™</span>
      </b>
    </p>

    <p style={lhNormal}>
      <span style={fs12TNR}>
        Xooker Deal Marketplace™ is a local and national deals website through
        which registered Members can buy certificates or deals
        (&quot;Certificates&quot;) that are redeemable for goods and/or services
        generally from local businesses in your area and in other cities where
        Xooker Deal Marketplace™ operates (collectively, these are referred to as
        &quot;Merchants&quot;). Xooker Deal Marketplace™ and Xooker, its partners
        and affiliates work with Merchants to provide you with the opportunity
        to purchase products or services at a time limited promotional rate from
        a particular Merchant. Xooker Deal Marketplace™ merely acts as the venue
        and conduit for this purchase: it is the Member who buys, and the
        Merchant who sells, the Certificate. The Merchant is the issuer of the
        Certificate and is the seller of the products and services to which the
        Certificate pertains, and as such, Xooker Deal Marketplace™ is not
        responsible for the quality, safety, usability, warranty and/or any
        other aspect of the goods and services provided. The Merchant (and not
        Xooker Deal Marketplace™) is fully responsible for the terms, conditions
        and restrictions for each Certificate, and for any and all injuries,
        illnesses, damages, claims, liabilities and costs (“Liabilities”)
        suffered by or in respect of you or any other customer caused in whole
        or in part by the Merchant or its products and services. You waive and
        release Xooker Deal Marketplace™ and Xooker and each of their
        subsidiaries, affiliates, partners, officers, directors, employees and
        agent from and against any Liabilities arising from or related to your
        use of the Certificate or the goods and/or services of any Merchant.
      </span>
    </p>

    <p style={lhNormal}>
      <span style={fs12TNR}>
        The Merchant is also responsible for complying with unclaimed property
        laws with respect to any unused Certificates. Some states' unclaimed
        property laws may allow you to recover some or all of the value
        associated with unused Certificates after a period of time. If you have
        questions regarding this, please contact the Merchant or your state's
        unclaimed property administrator, and not Xooker Deal Marketplace™. You
        also agree to comply with any and all applicable tax laws, including the
        reporting and payment of any taxes arising in connection with your
        purchase of Merchant Certificates or your use of Merchant Certificates
        to obtain products and services, and that the reporting and payment of
        any such applicable taxes are your responsibility.
      </span>
    </p>

    <p style={lhNormal}>
      <b>
        <span style={fs12TNR}>5.2. Descriptions of Merchant Offerings</span>
      </b>
    </p>

    <p style={lhNormal}>
      <span style={fs12TNR}>
        The Certificate sets forth the goods and services that can be purchased
        from the Merchant issuing the Certificate. Merchants are required to
        provide accurate and complete descriptions of those goods and services
        for the Certificates. However, while Xooker Deal Marketplace™ strives for
        accuracy in those descriptions, it cannot and does not warrant that
        descriptions of Certificates or other content of the Site regarding any
        Merchant’s deal is accurate, complete, reliable, current, or error-free.
        Xooker Deal Marketplace™ recommends you contact the Merchant directly if
        you have any questions regarding the description, terms or restrictions
        of their deal prior to purchasing a Certificate.
      </span>
    </p>

    <p style={lhNormal}>
      <b>
        <span style={fs12TNR}>5.3. Xooker Deal Marketplace™ Restrictions</span>
      </b>
    </p>

    <p style={lhNormal}>
      <span style={fs12TNR}>
        There are two values assigned to each Certificate. The “Paid Value” and
        the “Promotional Value”. The Paid Value is the actual amount you
        physically paid for the Certificate. The Promotional Value is the amount
        the merchant is offering over and above the Paid Value and is typically
        only redeemable for a limited period of time as specified on the
        Certificate (“Promotional Period”). An example might be a Certificate
        for $20 worth of goods from a merchant that you can purchase from Xooker
        Deal Marketplace™ at $10. In this case, the Paid Value is $10 and the
        Promotional Value is $20. The Promotional Value expires at the end of
        the Promotional Period specified on the Certificate (unless expiration
        of the Promotional Value is prohibited by law), but the Paid Value does
        not expire until it is used or redeemed (except to the extent expiration
        of the Paid Value is stated on the Certificate and permitted by law). In
        this example, you can redeem the Certificate for up to $20 worth of
        goods and services during the Promotional Period. After the Promotional
        Period, you can still redeem the Certificate for up to $10 of the Paid
        Value unless and until said amount has been used or redeemed. Please
        review Section 5.4 for more information on expiration dates applicable
        to the Certificates.
      </span>
    </p>

    <p style={lhNormal}>
      <span style={fs12TNR}>
        Except as otherwise stated on a Certificate or required by law, the
        following terms and conditions apply to all Certificates from all
        Merchants:
      </span>
    </p>

    <ul>
      <li style={lhNormal}>
        <span style={fs12TNR}>
          Certificates cannot be combined with any other coupons, discounts, or
          promotions.
        </span>
      </li>
      <li style={lhNormal}>
        <span style={fs12TNR}>
          If an expiration date for the promotion is stated, then the
          Promotional Value expires on the expiration date.
        </span>
      </li>
      <li style={lhNormal}>
        <span style={fs12TNR}>
          Certificates are not redeemable for cash, except as required by
          applicable law.{" "}
        </span>
      </li>
      <li style={lhNormal}>
        <span style={fs12TNR}>Certificates cannot be sold or transferred.</span>
      </li>
      <li style={lhNormal}>
        <span style={fs12TNR}>
          No refunds, cash back, or credit will be issued for the Promotional
          Value.
        </span>
      </li>
      <li style={lhNormal}>
        <span style={fs12TNR}>
          In the event you partially use the Promotional Value, your redemption
          of the purchase of Merchant's products or services will be allocated
          by the Merchant against the Paid Value first, and then against the
          Promotional Value. No refunds, cash back, or credit will be issued for
          any partially used Promotional Value.
        </span>
      </li>
      <li style={lhNormal}>
        <span style={fs12TNR}>
          Neither Xooker Deal Marketplace™ nor the Merchant will be responsible
          for lost or stolen Certificates.
        </span>
      </li>
      <li style={lhNormal}>
        <span style={fs12TNR}>
          Certificates may not be duplicated and can only be redeemed once. Any
          such duplicates are null and void.
        </span>
      </li>
      <li style={lhNormal}>
        <span style={fs12TNR}>
          Certificates or the Promotional Value cannot be used for taxes, tips,
          prior balances, or shipping or handling charges that might be imposed,
          where applicable, unless otherwise specified in the Restrictions.
        </span>
      </li>
      <li style={lhNormal}>
        <span style={fs12TNR}>
          Use of Certificates for alcoholic beverages is at the Merchant's
          discretion in accordance with applicable laws
        </span>
      </li>
    </ul>

    <p style={lhNormal}>
      <span style={fs12TNR}>
        In addition to the conditions that apply to your use of the Xooker Deal
        Marketplace website and purchase of Certificates generally, each
        Certificate you purchase through the Xooker Deal Marketplace™ website is
        subject to certain additional terms and restrictions between you and the
        Merchant that apply to that Certificate (&quot;Restrictions&quot;). The
        Restrictions specific to a given deal appear in the deal’s title,
        description and restrictions areas of the page where you purchase the
        Certificate. Restrictions are also displayed on the printed Certificate.
        The applicable Restrictions form a contract between you and the
        Merchant. If you buy a Certificate, you accept those Restrictions with
        the Merchant. Please read them carefully. Xooker Deal Marketplace™ is not
        a party to any of these terms between you and the Merchant. Certificates
        are redeemable in only the state (or states) where the Merchant's
        locations specified on the Certificate exist.
      </span>
    </p>

    <p style={lhNormal}>
      <b>
        <span style={fs12TNR}>5.4. Certificate Expiration</span>
      </b>
    </p>

    <p style={lhNormal}>
      <span style={fs12TNR}>
        Merchants may specify that the Paid Value or Promotional Value (or both)
        may expire after a specified date. For Certificates redeemable for goods
        or services, the Paid Value will expire 5 years from the date of
        issuance, except that Merchants are not permitted to expire the Paid
        Value of Certificates that are redeemable in any state that prohibits
        expiration periods, including CA, CT, FL, ME, MA, MN, MT, NH, ND, NJ,
        OR, RI, and WA, or provides for a longer period of redemption than 5
        years (in which case the longer period shall apply). Moreover, Merchants
        are prohibited from incrementally reducing the Paid Value of a
        Certificate over time due to non-use or otherwise (e.g., through
        dormancy, service or similar fees). Merchants are solely responsible for
        complying with the laws in their states.
      </span>
    </p>

    <p style={lhNormal}>
      <span style={fs12TNR}>
        You must redeem the Promotional Value of the Merchant’s Certificate
        before the end of the Promotional Period specified on the Certificate.
        The Merchant is not obligated to honor the Promotional Value of the
        Merchant Offer after the end of the Promotional Period.
      </span>
    </p>

    <p style={lhNormal}>
      <span style={fs12TNR}>
        If you are purchasing a Certificate that is redeemable for an event that
        is to take place on a specific date (e.g., a concert, art show, cruise,
        trip, lodging, etc.) (“Event-Related Certificate”), you must redeem the
        Event-Related Certificate before or on the event date since the
        Event-Related Certificate will not be redeemable thereafter. Unless
        otherwise specified in the Restrictions, you will not be eligible to
        receive a refund from the Merchant or use the Event-Related Certificate
        if you fail to redeem the Event-Related Certificate for the stated event
        date. Event dates are not treated as expiration dates under our
        Certificate Expiration policy.
      </span>
    </p>

    <p style={lhNormal}>
      <span style={fs12TNR}>
        For more information on Certificate expiration dates, please see our FAQ
        page at{" "}
      </span>
      <a href="https://www.xookerdealmarketplace.com/faq">
        https://www.xookerdealmarketplace.com/faq
      </a>
      <span style={fs12TNR}>
        and carefully review the Restrictions of each Certificate you purchase
        to identify the expiration date(s) applicable to that Certificate.
      </span>
    </p>

    <p style={lhNormal}>
      <span style={fs12TNR}>&nbsp;</span>
    </p>

    <p style={lhNormal}>
      <b>
        <span style={fs12TNR}>5.5. Purchasing and Redeeming Certificates</span>
      </b>
    </p>

    <p style={lhNormal}>
      <span style={fs12TNR}>
        If you want to purchase a Certificate that you see in one of our
        promotional messages or on our Site, you must log in to your account on
        our Sites and make an offer to purchase the Certificate by entering your
        credit card information and following all of the other instructions. If
        you want to make an offer for a Certificate, but you do not have a
        Member account, you will be prompted to create one.
      </span>
    </p>

    <p style={lhNormal}>
      <span style={fs12TNR}>
        Most Xooker Deal Marketplace™ Certificates by Merchants do not have a
        requirement for a minimum number of Members to sign up within the
        prescribed time period to be issued. These Certificate purchases will be
        charged to your credit card for your Payment immediately on completion
        of your purchase, and a purchase confirmation will be emailed to you on
        completion of the purchase transaction. However, if a particular
        Certificate has a requirement for a minimum number of Members to sign up
        within the prescribed time period, the Certificate’s offer page on the
        Site will clearly display the requirement on that page. In addition,
        Merchants may limit the number of Certificates that can be issued to any
        individual or in total, which limitations will be disclosed on the
        Certificate’s offer page on the Site.
      </span>
    </p>

    <p style={lhNormal}>
      <span style={fs12TNR}>
        You will not receive a Certificate, and your credit card will not be
        charged for your Payment, until we send you a message confirming that
        your offer to purchase a Certificate has been accepted by the Merchant.
        If the required number of Members does not sign up within the prescribed
        time period, then the Merchant will not issue that particular
        Certificate. If the Merchant has placed a limit on the total number of
        Certificates that can be issued, then you may not receive a Certificate
        if you place your order after that limit was reached. If, however, you
        receive a notification that your offer was accepted by the Merchant,
        then your credit card will be charged for your Payment and you can view
        the Certificate by logging into your account or from your purchase
        confirmation sent to you by email. The Certificate is automatically
        added to your mobile Xooker wallet three (3) hours after purchase unless
        otherwise noted. Each Certificate can only be redeemed or used with the
        Merchant once. If you purchase more than one Certificate for a specific
        deal (subject to any applicable restrictions on the number of
        Certificates per customer), your Certificate/Certificates will
        automatically be added to your mobile Xooker wallet three (3) hours
        after purchase unless otherwise noted.{" "}
      </span>
    </p>

    <p style={lhNormal}>
      <b>
        <span style={fs12TNR}>
          To redeem your Certificate, you must download and use the Xooker free
          app
        </span>
      </b>
      <span style={fs12TNR}>
        {" "}
        which will access your Certificate to the applicable Merchant via the
        Xooker app{" "}
        <span style={{ background: "yellow" }}>
          (insert redemption process)
        </span>
        . However, specific redemption instructions may be included on the
        Certificate that will describe other redemption methods (such as
        entering the Certificate's code into a website or displaying the
        Certificate to a Merchant via a mobile device). Your Certificate will
        generally not be usable until after three (3) hours from purchase unless
        otherwise noted. We will maintain the copy of the non-redeemed purchased
        Certificate in your Member Area when you are logged into Xooker Deal
        Marketplace, so that you may access it at any time. You can also contact
        us from our Contact Us page at (insert contact information link) to
        request a resend of your purchase confirmation.{" "}
      </span>
    </p>

    <p style={lhNormal}>
      <span style={fs12TNR}>
        Exceeding or attempting to exceed quantity limits when purchasing a
        Certificate is expressly prohibited. Using any account to purchase
        Certificates for resale, or for speculative, false, fraudulent or any
        other purpose not expressly permitted in these Terms of Service or a
        specific offer within Xooker Deal Marketplace™ is also prohibited.
      </span>
    </p>

    <p style={lhNormal}>
      <b>
        <span style={fs12TNR}>5.6. Certificate Refunds</span>
      </b>
    </p>

    <p style={lhNormal}>
      <span style={fs12TNR}>
        Xooker Deal Marketplace™ will always offer a full refund or credit of the
        Paid Value on all non-expired, unused Certificates within seven (7) days
        of their purchase by the Member from Xooker Deal Marketplace™, unless
        explicitly stated otherwise in a particular deal’s restrictions.
        Requests for refunds after seven (7) days are at the sole discretion of
        the Merchant providing the products or services described in the
        Certificate. In addition, Xooker Deal Marketplace™ will always honor your
        request for a refund of the Paid Value of any unredeemed Certificate if
        the Merchant goes out of business before the Promotional Period expires.
      </span>
    </p>

    <p style={lhNormal}>
      <span style={fs12TNR}>
        Except as set forth in this paragraph, Xooker Deal Marketplace™ will not
        offer any refund or credit at any time after a Member’s purchase for any
        Event-Related Certificates that take place on a specific date (e.g., a
        concert, art show, cruise, trip, lodging, etc.). Please refer to the
        Merchant’s Event-Related Restrictions and restrictions to determine if
        any refund terms are available directly from the Merchant. If for some
        reason the event corresponding to the Event- Related Certificate is
        canceled or rescheduled by Xooker Deal Marketplace™ or the Merchant, we,
        or the Merchant, will send you an email notifying you prior to such
        cancelation or rescheduling. If the event is rescheduled, the email to
        you will include the new date for the date-specific Event-Related
        Certificate. If you cannot make the new date for the Event-Related
        Certificate, you will be entitled to a refund of the Paid Value upon
        request within 48 hours of the email notification with the new date for
        the Event-Related Certificate. If, however, the Event-Related
        Certificate is canceled and will not be rescheduled, we will
        automatically refund you the Paid Value of the Event-Related
        Certificate.
      </span>
    </p>

    <p style={lhNormal}>
      <span style={fs12TNR}>
        This Refund Policy is in addition to any rights that you may have under
        applicable law.
      </span>
    </p>

    <p style={lhNormal}>
      <span style={fs12TNR}>
        If you have trouble redeeming your Certificates for any reason, please
        contact us at{" "}
      </span>
      <a href="https://www.xookerdealmarketplace.com/contact-us">
        https://www.xookerdealmarketplace.com/contact-us
      </a>
      <span style={fs12TNR}>
        so we can work with the Merchant to resolve your issue.
      </span>
    </p>

    <p style={lhNormal}>
      <b>
        <span style={fs12TNR}>
          5.7. Xooker Deal Marketplace™ Referral Program
        </span>
      </b>
    </p>

    <p style={lhNormal}>
      <span style={fs12TNR}>
        Xooker Deal Marketplace™ occasionally enables you to refer friends to
        Xooker Deal Marketplace™ in select cities where Xooker Deal Marketplace™
        operates (“Referral Program”). A link to the Referral Program’s rules
        will be available on the eligible city’s Xooker Deal Marketplace™ pages
        when a Referral Program is active in a particular city. A city’s Xooker
        Deal Marketplace™ pages are identified by the city reference at the top
        of every offer’s detail page. Since Referral Program rules may vary from
        city to city on the Xooker Deal Marketplace™ Sites, please ensure you
        follow the correct city’s Referral Program rules. You may be eligible to
        receive rewards in the form of referral credit (credit available for use
        toward future Xooker Deal Marketplace™ deal purchases) or to earn other
        benefits for referring friends. If you wish to refer friends to Xooker
        Deal Marketplace™, we provide you a unique referral link, which you can
        share directly with others via email, social media websites, or other
        communications methods. If someone clicks your link and takes a
        qualifying action, we may attribute that referral to you for purposes
        such as awarding reward credit. Credits are only usable in the Xooker
        Deal Marketplace™ city where they are earned, and may not be pooled with
        other Members or combined from another Xooker Deal Marketplace’s city’s
        Referral Program. For example if Xooker Deal Marketplace™ operates a
        referral program in Miami, FL the terms of the Miami Referral Program
        apply to referrals for eligible Certificates purchased from Miami Xooker
        Deal Marketplace™ pages, and any credit earned from the Miami Referral
        Program can be only be used for future Certificate purchases from Miami
        Xooker Deal Marketplace™ pages. Xooker Deal Marketplace™ may impose
        restrictions on the number of rewards allowed per member, and in Xooker
        Deal Marketplace’s sole discretion, render void any credit due or
        previously issued to a Member, if fraud or any activity contrary to the
        program’s rules is suspected.
      </span>
    </p>

    <p style={lhNormal}>
      <b>
        <span style={fs12TNR}>5.8. Promotion Codes</span>
      </b>
    </p>

    <p style={lhNormal}>
      <span style={fs12TNR}>
        Xooker Deal Marketplace™ may offer promotion codes (“Xooker Promo Codes”)
        that Members can apply to the future purchase of Certificates. In order
        for a Xooker Promo Code to apply, it must be entered in the payment
        section of the Xooker Deal Marketplace™ purchase transaction page when
        purchasing a Certificate. Xooker Promo Codes cannot be applied to
        previously placed purchases. Xooker Promo Codes are not transferable and
        not redeemable for cash, credit, or Referral Program rewards. Xooker
        Promo Codes are not available for use on every Xooker Deal Marketplace™
        Certificate offer. Xooker Promo Codes are only valid for purchases from
        the Xooker Deal Marketplace’s city pages from the Xooker Deal
        Marketplace city they were issued. Xooker Promo Codes may have quantity
        or time-based restrictions and other restrictions as specified by Xooker
        Deal Marketplace™. Only one Xooker Promo Code may be used per purchase
        and Xooker Promo Codes can only be used one time per person. The value
        of a Xooker Promo Code can never exceed the value of a purchase.
      </span>
    </p>

    <p style={lhNormal}>
      <span style={fs12TNR}>
        Merchants may also issue their own promotion codes (“Merchant Promo
        Codes”) in connection with Certificates issued by them. Such Merchant
        Promo Codes may be required to complete the purchase of the product or
        service described in the Certificate, such as completing an online
        purchase. Merchant Promo Codes are subject to the terms and conditions
        applicable to Certificates, including, but not limited to, applicable
        quantity or time-based restrictions, restrictions on transferability,
        and no cash redemption.
      </span>
    </p>

    <p style={lhNormal}>
      <b>
        <span style={fs10TNR}>6. Your Use of Xooker Deal Marketplace™</span>
      </b>
    </p>

    <p style={lhNormal}>
      <b>
        <span style={fs12TNR}>
          6.1. Copyright and Other Intellectual Property Rights
        </span>
      </b>
    </p>

    <p style={lhNormal}>
      <span style={fs12TNR}>
        All material published on the Sites, including deal content, articles,
        photos, Content Feeds, graphics, bulletin board postings, audio and
        video clips, trademarks, service marks, and other content
        (&quot;Content&quot;), is copyrighted or trademarked either by Xooker
        Deal Marketplace™, Xooker or publishing the Site, or by other Content or
        Merchant deal providers who have licensed their content for use on the
        Sites. Additionally, the entire Content of Xooker Deal Marketplace™ is
        protected by copyright as a collective work owned by Xooker. Except as
        permitted under Section 6.2, you may not reproduce, republish or
        redistribute Content or any portions thereof, including, without
        limitation, Content provided by licensors, other deal providers and
        other third parties, including Member Content, without the written
        consent of the applicable copyright owner. Xooker® is a registered
        trademark of Xooker, LLC. Unauthorized use is strictly prohibited.
      </span>
    </p>

    <p style={lhNormal}>
      <b>
        <span style={fs12TNR}>
          6.2. License Grant to Access Xooker Deal Marketplace™
        </span>
      </b>
    </p>

    <p style={lhNormal}>
      <span style={fs12TNR}>
        Subject to these Terms of Service, Xooker Deal Marketplace™ grants you
        permission to access the Sites and view the Content solely for your
        personal, non-commercial use. In addition to viewing Content online, you
        may electronically store a reasonable portion of the Site Content for
        your personal, non-commercial use by making a single electronic copy on
        your computer's hard drive, or a single copy on a disk or other media or
        a single copy in printed form. You agree, however, that you will not
        store or archive a significant portion of the Content or create a
        database using the Content.
      </span>
    </p>

    <p style={lhNormal}>
      <span style={fs12TNR}>
        These rules also apply to your use of the Xooker Deal Marketplace™ Sites:
      </span>
    </p>

    <ol>
      <li style={lhNormal}>
        <span style={fs12TNR}>
          You will not in any way infringe or misappropriate any of the
          intellectual property in and to the Content accessible through Xooker
          Deal Marketplace™. This means you agree not to copy, modify, publish,
          transmit, create derivative works from, transfer, sell or display the
          Content, including logos, trademarks or service marks, or otherwise
          violate the proprietary rights of Xooker Deal Marketplace™ or others
          except as expressly permitted herein.
        </span>
      </li>
      <li style={lhNormal}>
        <span style={fs12TNR}>
          You will not reuse, republish or otherwise distribute the Content or
          any modified or altered versions of it, whether over the World Wide
          Web or otherwise, and whether or not for payment, without the express
          written permission of Xooker Deal Marketplace™ or a third-party
          copyright holder, except that in some cases you may use individual
          items that appear on Xooker Deal Marketplace™ as specifically
          designated by the functionality of Xooker Deal Marketplace™ (e.g.,
          e-mail a deal to a friend or share a deal on social media sites). In
          such cases we communicate such rights to you directly in the
          applicable portion of the Content.
        </span>
      </li>
      <li style={lhNormal}>
        <span style={fs12TNR}>
          You will cooperate promptly and completely with any reasonable request
          by Xooker or Xooker Deal Marketplace™ related to an investigation of
          infringement of copyright or other proprietary right.
        </span>
      </li>
    </ol>

    <p style={lhNormal}>
      <b>
        <span style={fs12TNR}>6.3. Member-Submitted Content</span>
      </b>
    </p>

    <p style={lhNormal}>
      <span style={fs12TNR}>
        Members and other users of the Sites may be able, as dictated by the
        functionality of the Sites, to submit or to otherwise make available
        messages, e-mails, photographs, videos and other content for display on
        the Sites (&quot;Member Content&quot;). You are solely responsible for
        Member Content that you submit, and Xooker Deal Marketplace™ acts as a
        passive conduit for your online distribution and publication of Member
        Content. Member Content must conform to the guidelines below. Without
        limiting any of its rights in law and equity, Xooker Deal Marketplace™
        reserves the right to remove any Member Content for any reason in its
        sole discretion including any Member Content that it believes may
        violate these Terms of Service, any applicable law or any copyright or
        other third-party rights.
      </span>
    </p>

    <p style={lhNormal}>
      <span style={fs12TNR}>
        By submitting or otherwise making available any Member Content to Xooker
        Deal Marketplace™, you automatically grant Xooker and Xooker Deal
        Marketplace a nonexclusive, royalty-free, worldwide, perpetual,
        irrevocable, sublicensable (through multiple tiers), license to use,
        modify, copy, distribute, transmit, publicly display, publicly perform,
        publish, adapt, create derivative works of, distribute, transfer or sell
        any such Member Content, for any purpose, including commercial purposes
        and in connection with advertising for the sole benefit of Xooker Deal
        Marketplace (collectively, &quot;use&quot;), in any type of media or in
        any form now known or later developed, without any payment to you. In
        addition, you automatically waive and give up any claim that any use of
        such Member Content violates any of your rights, including privacy
        rights, publicity rights, moral rights or any other right, including the
        right to approve the way Xooker Deal Marketplace™ uses such content. You
        also grant Xooker and Xooker Deal Marketplace™ the right to use any
        material, information, ideas, concepts, know-how, or techniques
        contained in any Member Content or other communication you provide,
        submit, or otherwise make available to Xooker Deal Marketplace™ or to
        Xooker for any purpose whatsoever, including, without limitation,
        commercial purposes. By submitting Member Content, you automatically
        warrant and represent to Xooker and Xooker Deal Marketplace™ that you are
        the owner of all intellectual property rights in and to the Member
        Content or that you otherwise have all sufficient rights to grant the
        license above, and that use of the Member Content by Xooker Deal
        Marketplace does not conflict or violate any agreement to which you are
        bound. By submitting Member Content, you further warrant and represent
        that the Member Content does not infringes on any third-party right of
        privacy, right of publicity, or any third-party copyright, trademark,
        patent, or trade secret or any other third-party right or proprietary
        interest.
      </span>
    </p>

    <p style={lhNormal}>
      <b>
        <span style={fs12TNR}>6.4. Content Feeds</span>
      </b>
    </p>

    <p style={lhNormal}>
      <i>
        <span style={fs12TNR}>6.4.1. License Grant for Content Feeds</span>
      </i>
    </p>

    <p style={lhNormal}>
      <span style={fs12TNR}>
        Xooker Deal Marketplace™ offers or may offer content feeds, consisting of
        a selection of offer details, deal headlines, summaries, text blurbs,
        and links to full deal content, which are delivered using Really Simple
        Syndication (&quot;RSS&quot;) technology, other XML (extensible Markup
        Language) technology, or other syndication technology (&quot;Content
        Feed(s)&quot;). Subject to these Terms of Service, and to the extent
        that Xooker Deal Marketplace™ elects to offer Content Feeds(s), Xooker
        Deal Marketplace™ grants you a revocable, nontransferable,
        non-sublicensable, royalty-free, nonexclusive license to display the
        Content Feeds on your personal Web site or blog (&quot;Personal
        Site&quot;). For purposes of these Terms of Service, &quot;Content
        Feed(s)&quot; includes the Content included therein, or any portion
        thereof. The foregoing license expressly excludes Content from the
        Xooker Deal Marketplace™ Site not specifically included in the Content
        Feed(s); by way of example only, if the Content Feed(s) include only the
        deal headline and summary of a deal on Xooker Deal Marketplace™, the
        foregoing license does not give you the right to display the entire deal
        content on your Site. Content Feeds shall not be reproduced, displayed
        or use on any website that is used for commercial purposes except with
        the prior written consent of Xooker Deal Marketplace™.
      </span>
    </p>

    <p style={lhNormal}>
      <i>
        <span style={fs12TNR}>6.4.2. Reservation of Rights</span>
      </i>
    </p>

    <p style={lhNormal}>
      <span style={fs12TNR}>
        Except as expressly set forth in Section 6.4.1, and/or unless otherwise
        consented to in writing by Xooker Deal Marketplace™, you may not,
        directly or indirectly: (a) sell, modify, translate, copy, publish,
        transmit, distribute or otherwise disseminate the Content Feed(s); (b)
        delete or fail to display any promotional taglines included in the
        Content Feed(s); or (c) rent, lease, or otherwise transfer rights to any
        Content Feeds.
      </span>
    </p>

    <p style={lhNormal}>
      <i>
        <span style={fs12TNR}>
          6.4.3. Further Restrictions; no Modification
        </span>
      </i>
    </p>

    <p style={lhNormal}>
      <span style={fs12TNR}>
        Unless otherwise consented to in writing by Xooker Deal Marketplace™, you
        will: (a) display the Content Feed on your Personal Site in the exact
        form received by you, and not modify or edit it; (b) ensure that the
        fundamental meaning of the Content Feed is not changed or distorted; (c)
        comply with all applicable laws and all limitations and restrictions (if
        any) placed by Xooker Deal Marketplace™ on the use, display or
        distribution of any Content Feed. You will not (s) archive any Content
        Feeds for access by users at any future date after the Content Feed has
        been removed from your Personal Site; (t) display the name, logo,
        trademark or other identifier of another person on your Personal Site in
        such a manner as to give the viewer the impression that such other
        person is a publisher or distributor of Xooker Deal Marketplace™; (u)
        remove, conceal or obliterate any copyright or other proprietary notice
        or any credit-line, date-line or other mark or source identifier
        included on the Content Feed(s), including without limitation, the size,
        color, location or style of Xooker Deal Marketplace's marks; (v) make
        any representation or warranty on behalf of Xooker Deal Marketplace™ or
        make any disparaging or derogatory statement regarding Xooker Deal
        Marketplace or the Content Feed; (w) incorporate any Content Feeds on
        any site containing nudity or pornographic material, that displays
        material that exploits children under the age of 18, that promotes or
        provides instructional information about illegal activities or physical
        harm or injury against any group or individual, or that uses the Xooker
        Deal Marketplace™ in any manner that is obscene, defamatory, libelous,
        invasive of personal privacy or misleading; (x) display the Content Feed
        in a manner that does not allow for successful linking and redirection
        to, and delivery of, Xooker Deal Marketplace's page; (y) frame any
        Xooker Deal Marketplace™ page; or (z) fail to stipulate that the Content
        Feed is supplied by Xooker Deal Marketplace™ and is protected by
        copyright and owned by Xooker.
      </span>
    </p>

    <p style={lhNormal}>
      <i>
        <span style={fs12TNR}>6.4.4. Warranty</span>
      </i>
    </p>

    <p style={lhNormal}>
      <span style={fs12TNR}>
        If you use the Content Feed services, you warrant that your Personal
        Site does not infringe the intellectual property of any third parties.
        You further warrant that your Personal Site violates no applicable law.
      </span>
    </p>

    <p style={lhNormal}>
      <i>
        <span style={fs12TNR}>6.4.5. Limitations on linking and Framing</span>
      </i>
    </p>

    <p style={lhNormal}>
      <span style={fs12TNR}>
        You are free to establish a hypertext link to the home page of our Sites
        so long as the link does not state or imply any sponsorship of your
        website or service by us or by our Xooker Deal Marketplace™ site.
        However, you may not, without our prior written permission, deep-link to
        any portions of our Sites, frame or inline link any of the Content of
        our Sites, or incorporate into another website or other service any of
        our material, Content or intellectual property, except with the prior
        written consent of Xooker Deal Marketplace™ and Xooker.
      </span>
    </p>

    <p style={lhNormal}>
      <b>
        <span style={fs12TNR}>6.5. Site Availability</span>
      </b>
    </p>

    <p style={lhNormal}>
      <span style={fs12TNR}>
        You acknowledge that there may be interruptions in service or events
        that are beyond our control. While we use reasonable efforts to keep the
        Xooker Deal Marketplace™ Sites accessible, the Sites may be unavailable
        from time to time for any reason including, without limitation, routine
        maintenance. You understand and acknowledge that due to circumstances
        both within and outside of our control site access may be interrupted,
        suspended or terminated. Xooker Deal Marketplace™ retains the right at
        our sole discretion to deny service, or access to the Sites to anyone or
        an account, at any time and for any reason.
      </span>
    </p>

    <p style={lhNormal}>
      <b>
        <span style={fs12TNR}>6.6. Websites of Others</span>
      </b>
    </p>

    <p style={lhNormal}>
      <span style={fs12TNR}>
        The Xooker Deal Marketplace™ Sites contain links to websites maintained
        by other parties. These links are provided solely as a convenience to
        you and not because we endorse or have an opinion about the contents on
        such websites. We expressly disclaim any representations regarding the
        content or accuracy of materials on such websites or the privacy
        practices of those websites. If you decide to access websites maintained
        by other parties, you do so at your own risk.
      </span>
    </p>

    <p style={lhNormal}>
      <b>
        <span style={fs10TNR}>
          7. Digital Millennium Copyright Act (&quot;DMCA&quot;)
        </span>
      </b>
    </p>

    <p style={lhNormal}>
      <span style={fs12TNR}>
        Xooker Deal Marketplace™ respects the copyrights of others and expects
        its users to do the same. In accordance with the Digital Millennium
        Copyright Act (&quot;DMCA&quot;), the text of which may be found on the
        U.S. Copyright Office site at{" "}
      </span>
      <a href="http://www.copyright.gov/legislation/dmca.pdf">
        <span style={fs12TNR}>
          http://www.copyright.gov/legislation/dmca.pdf
        </span>
      </a>
      <span style={fs12TNR}>
        , Xooker Deal Marketplace™ will respond expeditiously to notices of
        alleged copyright infringement that are duly reported to our Designated
        Copyright Agent identified in the notice below. We will disable and/or
        terminate the accounts of Users who are repeat infringers.
      </span>
    </p>

    <p style={lhNormal}>
      <span style={fs12TNR}>
        If you believe that Xooker Deal Marketplace or any user of Xooker Deal
        Marketplace has infringed your copyright, please notify our Copyright
        Agent and provide the following information.
      </span>
    </p>

    <ol>
      <li style={lhNormal}>
        <span style={fs12TNR}>
          An identification of the copyrighted work that you claim has been
          infringed, or, if multiple copyrighted works at a single online site
          are covered by a single notification, a representative list of such
          works at that site.
        </span>
      </li>
      <li style={lhNormal}>
        <span style={fs12TNR}>
          An identification of the material on Xooker Deal Marketplace™ that you
          claim is infringing or is subject to infringing activity that is to be
          removed or access to which is to be disabled, with enough detail
          (including without limitation the URL of the material) to allow us to
          locate the material on our site.
        </span>
      </li>
      <li style={lhNormal}>
        <span style={fs12TNR}>
          Your name, address, telephone number and e-mail address.
        </span>
      </li>
      <li style={lhNormal}>
        <span style={fs12TNR}>
          A statement by you that you have a good-faith belief that the disputed
          use is not authorized by the copyright owner, its agent or the law.
        </span>
      </li>
      <li style={lhNormal}>
        <span style={fs12TNR}>
          A statement by you declaring that the above information in your Notice
          is accurate made under penalty of perjury, and that you are authorized
          to act on behalf of the owner of an exclusive copyright interest
          involved.
        </span>
      </li>
      <li style={lhNormal}>
        <span style={fs12TNR}>
          A physical or electronic signature of a person authorized to act on
          behalf of the owner of an exclusive right that is allegedly infringed.
        </span>
      </li>
    </ol>

    <p style={lhNormal}>
      <span style={fs12TNR}>
        The Copyright Agent for Xooker Deal Marketplace™ is Kyle Harris, who can
        be reached at 651 Perimeter Drive, Suite 400, Lexington, KY 40517, or at
        kharris@Xooker.com. You acknowledge that if you fail to comply with all
        of the requirements of this Section, your DMCA notice may not be valid.
      </span>
    </p>

    <p style={lhNormal}>
      <span style={fs12TNR}>&nbsp;</span>
    </p>

    <p style={lhNormal}>
      <b>
        <span style={fs10TNR}>8. Online Conduct</span>
      </b>
    </p>

    <ol>
      <li style={lhNormal}>
        <span style={fs12TNR}>
          Provide any information that is false, misleading or inaccurate.
        </span>
      </li>
      <li style={lhNormal}>
        <span style={fs12TNR}>
          Use any portion of Xooker Deal Marketplace™ for any unlawful purpose or
          otherwise fail to comply with all applicable domestic and
          international laws, statutes, ordinances and regulations.
        </span>
      </li>
      <li style={lhNormal}>
        <span style={fs12TNR}>
          Use any portion of Xooker Deal Marketplace™ for uploading, posting,
          e-mailing, transmitting or otherwise making available Member Content
          that infringes any patent, trademark, trade secret, copyright or other
          proprietary rights of any party.
        </span>
      </li>
      <li style={lhNormal}>
        <span style={fs12TNR}>
          Use any portion of Xooker Deal Marketplace™ for uploading, posting,
          e-mailing, transmitting or otherwise making available Member Content
          that is harmful to minors in any way, harassing, harmful, threatening,
          abusive, vulgar, obscene, defamatory, libelous, hateful, or racially,
          ethnically or otherwise objectionable.
        </span>
      </li>
      <li style={lhNormal}>
        <span style={fs12TNR}>
          Use any portion of Xooker Deal Marketplace™ for uploading, posting,
          e-mailing, transmitting or otherwise making available junk mail,
          commercial advertisements, or any other form of commercial
          solicitation.
        </span>
      </li>
      <li style={lhNormal}>
        <span style={fs12TNR}>
          Interfere with any other person's use of or the proper functioning of
          Xooker Deal Marketplace™.
        </span>
      </li>
      <li style={lhNormal}>
        <span style={fs12TNR}>
          Misrepresent your identity or impersonate any person.
        </span>
      </li>
      <li style={lhNormal}>
        <span style={fs12TNR}>
          Hold yourself out as sponsored by, endorsed by, or affiliated with
          Xooker or Xooker Deal Marketplace™.
        </span>
      </li>
      <li style={lhNormal}>
        <span style={fs12TNR}>
          Modify, translate, adapt, edit, decompile, disassemble, or reverse
          engineer any software programs used by Xooker or Xooker Deal
          Marketplace in connection with Xooker Deal Marketplace™.
        </span>
      </li>
      <li style={lhNormal}>
        <span style={fs12TNR}>
          Use or launch any automated means including spiders, robots, crawlers,
          scrapers and the like, to download or copy data or content from Xooker
          Deal Marketplace™
        </span>
      </li>
      <li style={lhNormal}>
        <span style={fs12TNR}>
          Distribute any material that contains software viruses or any other
          computer code, files, or programs that are designed or intended to:
          (i) disrupt, damage, or limit the functioning of Xooker Deal
          Marketplace, any software, hardware, or telecommunications equipment
          used in connection therewith; or (ii) damage or obtain unauthorized
          access to any data or other information of any third party.
        </span>
      </li>
      <li style={lhNormal}>
        <span style={fs12TNR}>
          Take any action that: (i) imposes or may impose, in Xooker Deal
          Marketplace's sole discretion, an unreasonable or disproportionately
          large load on its infrastructure; (ii) interferes or attempts to
          interfere with the proper working of Xooker Deal Marketplace™; or (iii)
          disrupts or diminishes the quality of, interferes with the performance
          of, or impairs the functionality of Xooker Deal Marketplace™.
        </span>
      </li>
    </ol>

    <p style={lhNormal}>
      <span style={fs12TNR}>
        To register a complaint about another user's conduct, please e-mail{" "}
      </span>
      <a href="mailto:info@xooker.com">
        <span style={fs12TNR}>info@xooker.com</span>
      </a>
      <span style={fs12TNR}>
        {" "}
        or write to Customer Service, Xooker Deal Marketplace™ 651 Perimeter
        Drive, Suite 400, Lexington, KY 40517, or call 1-844-523-9487.
      </span>
    </p>

    <p style={lhNormal}>
      <b>
        <span style={fs10TNR}>9. Disclaimer and Limitation of Liability</span>
      </b>
    </p>

    <p style={lhNormal}>
      <b>
        <span style={fs12TNR}>9.1. Disclaimer</span>
      </b>
    </p>

    <p style={lhNormal}>
      <span style={fs12TNR}>
        While Xooker Deal Marketplace™ strives for accuracy, it does not warrant
        or guarantee the accuracy or completeness of any information or database
        on the Sites, including, but not limited to, the terms and conditions of
        any Certificate or any descriptions of any product or service offered by
        any Merchant. . Nor does Xooker Deal Marketplace™ warrant or guarantee
        that any files available for downloading will be free of defects.
        Neither Xooker Deal Marketplace™ nor Xooker nor any of its information
        providers will be liable in any way to you or to other parties for
        delays, inaccuracies, errors or omissions in material published on any
        of the Xooker Deal Marketplace™ Sites.
      </span>
    </p>

    <p style={lhNormal}>
      <span style={fs12TNR}>
        The content, services, and features of Xooker Deal Marketplace™ and the
        Sites are subject to change without notice. The inclusion of any
        content, services, and features on Xooker Deal Marketplace™ Sites at a
        particular time does not imply or warrant that these products or
        services will be available at any time.
      </span>
    </p>

    <p style={lhNormal}>
      <span style={fs12TNR}>
        While we take reasonable steps to ensure that no viruses, worms, Trojan
        horses or other destructive properties are present, the entire risk as
        to the quality and performance of the Xooker Deal Marketplace™ Sites and
        the accuracy and completeness of any information is with you.
      </span>
    </p>

    <p style={lhNormal}>
      <span style={fs12TNR}>
        Opinions, advice and all other information expressed on Xooker Deal
        Marketplace forums, comment sections, blogs, and any other area where
        user-generated Content is displayed, represent the individual's own
        views and are not necessarily those of Xooker Deal Marketplace™. Xooker
        Deal Marketplace™ does not endorse and is not responsible for statements,
        advice and opinions made by anyone, and no oral or written information
        or advice given by a Xooker Deal Marketplace™ representative will create
        a warranty.
      </span>
    </p>

    <p style={lhNormal}>
      <span style={fs12TNR}>
        Xooker Deal Marketplace™ makes no representation or warranty, express or
        implied, written or oral, regarding the products and services offered by
        any Merchant. You agree that the Merchant is solely responsible for any
        and all claims and Liabilities relating to their product and services
        and the deals offered on or through the Xooker Deal Marketplace™ Sites.
        THE Xooker Deal Marketplace™ SITE AND SERVICES, INCLUDING ANY DEALS,
        PRODUCTS AND SERVICES OFFERED BY MERCHANTS, ARE PROVIDED ON AN &quot;AS
        IS&quot; AND &quot;AS AVAILABLE&quot; BASIS. WE MAKE NO WARRANTY OF ANY
        KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION,
        WARRANTIES OF MERCHANTABILITY OR FITNESS FOR A PARTICULAR PURPOSE OR
        NONINFRINGEMENT, OR WARRANTIES REGARDING THE ACCURACY, RELIABILITY OR
        COMPLETENESS OF THE CONTENT OR ANY OTHER SERVICE OR PRODUCT ON OR
        RELATED TO THE SERVICE (INCLUDING ANY LINK TO ANOTHER WEB SITE OR
        RESOURCE).
      </span>
    </p>

    <p style={lhNormal}>
      <b>
        <span style={fs12TNR}>9.2. Limitation of Liability</span>
      </b>
    </p>

    <p style={lhNormal}>
      <span style={fs12TNR}>
        In no event will Xooker Deal Marketplace™, Xooker, or their parents or
        affiliates be liable for (i) any incidental, consequential, or indirect
        damages (including, but not limited to, damages for loss of business
        profits, business interruption, loss of programs or information, and the
        like) arising out of the use of or inability to use the Sites, the
        Certificates, the goods and services of any Merchant, or any information
        or services provided on the Sites, even if Xooker Deal Marketplace™ has
        been advised of the possibility of such damages, (ii) any claim
        attributable to errors, omissions, or other inaccuracies published on
        the Sites, (iii) any failure of a merchant or advertiser to honor the
        terms of a deal or offer advertised on Xooker Deal Marketplace™ other
        than to refund the money that you have paid directly to Xooker Deal
        Marketplace, or (iv) any defect, shortcoming, misrepresentation or other
        failure of a Merchant or advertiser in performing its part of a deal on
        the Sites or in connection with the products and services supplied by
        that Merchant IN NO EVENT WILL Xooker Deal Marketplace™, XOOKER OR THEIR
        PARENTS' OR AFFILIATES' AGGREGATE LIABILITY ARISING OUT OF OR IN
        CONNECTION WITH THESE TERMS OF SERVICE OR THE SITES, WHETHER IN
        CONTRACT, TORT (INCLUDING NEGLIGENCE, PRODUCT LIABILITY OR OTHER
        THEORY), WARRANTY OR OTHERWISE, EXCEED AMOUNT THAT YOU HAVE PAID
        DIRECTLY TO XOOKER DEAL MARKETPLACE™ FOR THE SPECIFIC DEAL TO WHICH YOU
        ATTRIBUTE LIABILITY.
      </span>
    </p>

    <p style={lhNormal}>
      <span style={fs12TNR}>
        SOME STATES OR JURISDICTIONS DO NOT ALLOW THE EXCLUSION OR LIMITATION OF
        LIABILITY FOR CONSEQUENTIAL OR INCIDENTAL DAMAGES, SO THE ABOVE
        LIMITATION MAY NOT APPLY TO YOU.
      </span>
    </p>

    <p style={lhNormal}>
      <b>
        <span style={fs10TNR}>10. Indemnity</span>
      </b>
    </p>

    <p style={lhNormal}>
      <span style={fs12TNR}>
        You will defend, indemnify, and hold harmless Xooker Deal Marketplace™,
        Xooker and their parents and affiliates, and each of their respective
        officers, directors, employees and agents, from and against any
        liabilities, damages, lawsuits, claims, losses and expenses (including,
        but not limited to reasonable attorney’s fees and costs) arising out of
        or related to : (i) your use of and access of the Xooker Deal
        Marketplace Sites; (ii) your violation of any of these Terms of Service;
        (iii) your violation of any third-party right including any copyright,
        trademark, trade secret, or privacy right related to any Member Content
        submitted by you (if applicable) or your use of the Sites. This defense
        and indemnification obligation will survive the term and your use of the
        Xooker Deal Marketplace™ Sites.
      </span>
    </p>

    <p style={lhNormal}>
      <b>
        <span style={fs10TNR}>11. Miscellaneous</span>
      </b>
    </p>

    <p style={lhNormal}>
      <b>
        <span style={fs12TNR}>11.1. Termination</span>
      </b>
    </p>

    <p style={lhNormal}>
      <span style={fs12TNR}>
        We may terminate these Terms of Service, your account, or your access to
        Xooker Deal Marketplace™ at any time with or without notice to you. If,
        at the time of termination of your account or your access to the Sites,
        you have not received a Certificate for any deal that you have bought,
        Xooker Deal Marketplace™ will, in its sole discretion, either refund the
        purchase price or deliver the Certificate electronically to you. You may
        terminate these Terms of Service or your account by: (a) discontinuing
        your use of the Xooker Deal Marketplace™ Sites and (b) destroying and
        removing all copies of Content from your Site (if any) and that is
        otherwise in your possession and control.
      </span>
    </p>

    <p style={lhNormal}>
      <b>
        <span style={fs12TNR}>11.2. Jurisdiction</span>
      </b>
    </p>

    <p style={lhNormal}>
      <span style={fs12TNR}>
        This agreement between Xooker Deal Marketplace™ and its users will be
        governed and interpreted under the laws of the state of California,
        except that the Arbitration Provision shall be governed by the Federal
        Arbitration Act (“FAA”). Except as provided in Section 11.3 below,
        courts located in Fayette County, Kentucky have jurisdiction in any
        dispute arising from these Terms of Service. In the event that any
        provision of these Terms of Service is found to be in conflict with the
        law, such provision shall be restated to reflect the original intent,
        and all other terms and conditions shall remain in full force and
        effect.
      </span>
    </p>

    <p style={lhNormal}>
      <b>
        <span style={fs12TNR}>11.3. Dispute Resolution and Arbitration</span>
      </b>
    </p>

    <p style={lhNormal}>
      <span style={fs12TNR}>
        This Dispute Resolution and Arbitration provision (“Arbitration
        Provision”) facilitates the prompt and efficient resolution of any
        disputes that may arise between you and Xooker Deal Marketplace™.
        Arbitration is a form of private dispute resolution in which persons
        with a dispute waive their rights to file a lawsuit, to proceed in court
        and to a jury trial, and instead submit their disputes to a neutral
        third person (or arbitrator) for a binding decision. You have the right
        to opt-out of this Arbitration Provision (as explained below), which
        means you would retain your right to litigate your disputes in a court,
        either before a judge or jury.
      </span>
    </p>

    <p style={lhNormal}>
      <span style={fs12TNR}>
        You and we agree that any dispute, claim or controversy arising out of
        or relating in any way to our Sites or services, including any
        Certificates, user interfaces, these Terms of Service and this
        Arbitration Provision (collectively “Disputes”), shall be determined by
        binding arbitration instead of in courts of general jurisdiction.
        Arbitration is more informal than a lawsuit in court. Arbitration uses a
        neutral arbitrator instead of a judge or jury, allows for more limited
        discovery than in court, and is subject to very limited review by
        courts. Arbitrators can award the same damages and relief that a court
        can award, except that either party may seek injunctive or declaratory
        relief in a court of competent jurisdiction as specified in Section 11.2
        of these Terms of Service. You agree that, by agreeing to these Terms of
        Service, the U.S. Federal Arbitration Act governs the interpretation and
        enforcement of this provision, and that you and we are each waiving the
        right to a trial by jury or to participate in a class action. This
        arbitration provision shall survive termination of the Terms of Service
        and the termination of your account with us.
      </span>
    </p>

    <p style={lhNormal}>
      <span style={fs12TNR}>
        For all Disputes, whether pursued in court or arbitration, you must
        first give Xooker Deal Marketplace™ an opportunity to resolve the
        Dispute. You must commence this process by mailing written notification
        (“Pre-Arbitration Claim Resolution Notice”) to Xooker, 651 Perimeter
        Drive, Suite 400, Lexington, KY 40517 Attention: Legal Department. That
        written notification must include (1) your name, (2) your address, (3) a
        written description of your Dispute, and (4) a description of the
        specific relief you seek. If Xooker Deal Marketplace™ does not resolve
        the Dispute within 45 days after it receives your written notification,
        you may pursue your Dispute in arbitration. You may pursue your Dispute
        in a court only under the circumstances described below.
      </span>
    </p>

    <p style={lhNormal}>
      <span style={fs12TNR}>
        Notwithstanding the above, you or Xooker Deal Marketplace™ may choose to
        pursue a Dispute in court and not by arbitration if (a) the Dispute
        qualifies, it may be initiated in small claims court; or (b) YOU OPT-OUT
        OF THESE ARBITRATION PROCEDURES WITHIN 30 DAYS FROM THE DATE THAT YOU
        FIRST CONSENT TO THESE TERMS OF SERVICE (the “Opt-Out Deadline”). You
        may opt out of this Arbitration Provision by mailing written
        notification to Xooker, 651 Perimeter Drive, Suite 400, Lexington, KY
        40517 Attention: Legal Department. Your written notification must
        include (1) your name, (2) your address, and (3) a clear statement that
        you do not wish to resolve disputes with Xooker Deal Marketplace™ through
        arbitration. Your decision to opt-out of this Arbitration Provision will
        have no adverse effect on your relationship with Xooker Deal
        Marketplace. Any opt-out request received after the Opt-Out Deadline
        will not be valid and you must pursue your Dispute in arbitration or
        small claims court.
      </span>
    </p>

    <p style={lhNormal}>
      <span style={fs12TNR}>
        If this Arbitration Provision applies and the Dispute is not resolved by
        Pre-Arbitration Claim Resolution either you or Xooker Deal Marketplace™
        may initiate arbitration proceedings. The arbitration will be governed
        by the Commercial Arbitration Rules and the Supplementary Procedures for
        Consumer Related Disputes (collectively, &quot;AAA Rules&quot;) of the
        American Arbitration Association (&quot;AAA&quot;), as modified by these
        Terms of Service, and will be administered by the AAA. The AAA Rules and
        Forms are available online at www.adr.org, by calling the AAA at
        1-800-778-7879, or by writing to the Notice Address. The arbitrator is
        bound by these Terms of Service and the Arbitration Provision. All
        issues are for the arbitrator to decide, including issues relating to
        the scope and enforceability of this Arbitration Provision. Such award
        will be final and binding on the parties, except for any right of appeal
        provided by the FAA, and may be entered in any court having jurisdiction
        over the parties for purposes of enforcement.
      </span>
    </p>

    <p style={lhNormal}>
      <span style={fs12TNR}>
        You or Xooker Deal Marketplace™ may initiate arbitration in either
        Fayette, Kentucky or the federal judicial district that includes the
        address you provide in your Pre-Arbitration Claim Resolution Notice. In
        the event that you select the federal judicial district that includes
        the address you provide in your Pre-Arbitration Claim Resolution Notice,
        Xooker Deal Marketplace™ may transfer the arbitration to Fayette,
        Kentucky, in the event that it agrees to pay any additional fees or
        costs you incur as a result of the transfer, as determined by the
        arbitrator. If your claim is for US$10,000 or less, we agree that you
        may choose whether the arbitration will be conducted solely on the basis
        of documents submitted to the arbitrator, through a telephonic hearing,
        or by an in-person hearing as established by the AAA Rules. If your
        claim exceeds US$10,000, the right to a hearing will be determined by
        the AAA Rules.
      </span>
    </p>

    <p style={lhNormal}>
      <span style={fs12TNR}>
        Xooker Deal Marketplace™ will pay all arbitration filing fees and
        arbitrator’s costs and expenses upon your written request given prior to
        the commencement of the arbitration. You are responsible for all
        additional fees and costs that you incur in the arbitration, including,
        but not limited to, attorneys or expert witnesses. Fees and costs may be
        awarded as provided pursuant to applicable law and by the AAA Rules.
      </span>
    </p>

    <p style={lhNormal}>
      <span style={fs12TNR}>
        YOU AND WE AGREE THAT EACH MAY BRING CLAIMS AGAINST THE OTHER ONLY IN
        YOUR OR ITS INDIVIDUAL CAPACITY AND NOT AS A PLAINTIFF OR CLASS MEMBER
        IN ANY PURPORTED CLASS OR REPRESENTATIVE PROCEEDING. Further, unless
        both you and we agree otherwise, the arbitrator may not consolidate more
        than one person's claims with your claims, and may not otherwise preside
        over any form of a representative or class proceeding. If this specific
        provision is found to be unenforceable, then the entirety of this
        Arbitration Provision shall be null and void.{" "}
      </span>
    </p>

    <p style={lhNormal}>
      <span style={fs12TNR}>
        You understand and agree that by entering into these Terms of Service
        and this Arbitration Provision, you and Xooker Deal Marketplace™ are each
        waiving the right to a jury trial or a trial before a judge in a public
        court. In the absence of this Arbitration Provision, you and Xooker Deal
        Marketplace might otherwise have had a right or opportunity to bring
        Disputes in a court, before a judge or jury, and/or to participate or be
        represented in a case filed in court by others (including class
        actions). Except as otherwise provided below, those rights are waived.
        Other rights that you would have if you went to court, such as the right
        to appeal and to certain types of discovery, may be more limited or may
        also be waived.
      </span>
    </p>

    <p style={lhNormal}>
      <b>
        <span style={fs12TNR}>11.4. Severability</span>
      </b>
    </p>

    <p style={lhNormal}>
      <span style={fs12TNR}>
        If any provision of these Terms of Service shall be deemed unlawful,
        void or for any reason unenforceable, then that provision shall be
        deemed severable from these Terms of Service and shall not affect the
        validity and enforceability of any remaining provisions.
      </span>
    </p>

    <p style={lhNormal}>
      <b>
        <span style={fs12TNR}>11.5. Complete Agreement</span>
      </b>
    </p>

    <p style={lhNormal}>
      <span style={fs12TNR}>
        These Terms of Service represents the complete agreement concerning the
        subject matter hereof between the parties and supersedes all prior and
        contemporaneous agreements and understandings between them, whether
        written or oral.
      </span>
    </p>

    <p style={lhNormal}>
      <b>
        <span style={fs12TNR}>11.6. Force Majeure</span>
      </b>
    </p>

    <p style={lhNormal}>
      <span style={fs12TNR}>
        Neither party will be liable for any failure to perform any obligation
        (other than payment obligations) hereunder, or from any delay in the
        performance thereof, due to causes beyond its control, including
        industrial disputes of whatever nature, acts of God, public enemy, acts
        of government, failure of telecommunications, fire or other casualty.
      </span>
    </p>

    <p style={lhNormal}>
      <b>
        <span style={fs12TNR}>11.7. Void Where Prohibited by Law</span>
      </b>
    </p>

    <p style={lhNormal}>
      <span style={fs12TNR}>
        These Terms of Service are void where prohibited by law, and the right
        to access Xooker Deal Marketplace™ is revoked in such jurisdictions.
      </span>
    </p>

    <p style={lhNormal}>
      <b>
        <span style={fs12TNR}>11.8. Independent Contractors</span>
      </b>
    </p>

    <p style={lhNormal}>
      <span style={fs12TNR}>
        The parties hereto are independent contractors, and these Terms of
        Service create no partnership, joint venture, agency, franchise, sales
        representative or employment relationship between the parties. You have
        no authority to make or accept any offers or representations on our
        behalf and you shall not make any statement, on your Site (if any) or
        otherwise, that conflicts with these Terms of Service.
      </span>
    </p>

    <p style={lhNormal}>
      <b>
        <span style={fs10TNR}>12. Offices</span>
      </b>
    </p>

    <p style={lhNormal}>
      <span style={fs12TNR}>
        Xooker Deal Marketplace™, c/o Xooker, 651 Perimeter Drive, Suite 400,
        Lexington, KY 40517 USA or call 1-844-523-9487 or email info@xooker.com
      </span>
    </p>

    <p style={lhNormal}>
      <b>
        <span style={fs10TNR}>
          13. Questions and Comments About Xooker Deal Marketplace™
        </span>
      </b>
    </p>

    <p style={lhNormal}>
      <span style={fs12TNR}>
        We hope you enjoy using Xooker Deal Marketplace™. Questions and comments
        about the content of Xooker Deal Marketplace™ may be sent by e-mail to{" "}
      </span>
      <a href="mailto:info@xooker.com">
        <span style={fs12TNR}>info@xooker.com</span>
      </a>
      <span style={fs12TNR}>
        {" "}
        We try to read all comments sent to us and try to respond to as many as
        possible. Technical questions regarding your software, your
        configuration or your connection should be directed to your Internet
        access provider and/or wireless carrier. Xooker Deal Marketplace™ cannot
        address questions except those specifically about content and services
        we provide.
      </span>
    </p>
  </div>
);



// WEBPACK FOOTER //
// ./src/routes/TermsAndConditions/components/content.js